module.exports = __webpack_public_path__ + "static/media/setting-fill.8078104f.svg";